<ion-header><app-navheader [page]="isLogin()"></app-navheader>
  <img src="/../assets/img/black-arrow-login.png" class="black-arrow-login"/>
</ion-header>
<ion-content padding style="background-color: #04c4fc">
  <ion-item lines="none" class="blue-item ion-no-padding header">
    <ion-label><h1 class="h1-blue-page">{{ 'ACCOUNT.COUPON_ADD.HEADER' | translate }} </h1></ion-label>
  </ion-item>
  <div style="text-align: center; padding: 10px 36px 0 36px; color: #fff;" *ngIf="!profiles">{{'ACCOUNT.COUPON_ADD.TEXT' | translate}}</div>
  <div class="wrapper">
    <ion-list>
      <form #couponForm ="ngForm">
        <ng-container *ngIf="!profiles?.length">
          <ion-item lines="none" class="firstinput blue-item">
            <!-- <ion-label stacked>Code Promo</ion-label> -->
            <ion-input type="text" (ionChange) = "changeHandler()" [ngClass]="{'ng-invalid': error_coupon, 'ng-dirty': error_coupon}"
              [(ngModel)]="couponModel.coupon_code" name="coupon_code" id="coupon" #coupon_code="ngModel">
            </ion-input>
          </ion-item>
          <!-- <ion-item class="errortextpassword" [hidden] = "coupon_code.valid || coupon_code.pristine">Ce champs est obligatoire</ion-item> -->
          <ion-item lines="none" class="ion-text-wrap errortextt" [ngClass]="{'visible': error_coupon}">
            <ion-label>{{ error_coupon }}</ion-label>
          </ion-item>
          <ion-button class="connect" (click)="checkCode()">{{ 'ACCOUNT.COUPON_ADD.BUTTON' | translate }}</ion-button>
        </ng-container>
        <div class="avatars-wrapper clear">
          <div [hidden] ="!profiles?.length" style="text-align:center; text-transform: uppercase; font-size: 1.6rem; margin-bottom: 15px; color: #fff;">
            {{'ACCOUNT.COUPON_ADD.VALID.TEXT' | translate }}
          </div>
          <div [hidden] = "!profiles?.length" style="text-align: center; color: #fff; font-size: 1.6rem; margin-bottom: 20px;">
            {{'ACCOUNT.COUPON_ADD.VALID.DESCRIPTION' | translate:{newspaperList: newspaperList, duration: duration} }} {{'ACCOUNT.COUPON_ADD.VALID.PROFILE_SELECT' | translate}}
          </div>
          <div class="profile-avatar" [hidden] = "!profiles" *ngFor="let profile of profiles; let index = index; let c = count;">
            <img  *ngIf="!profile.profile_avatar_path" src="/../assets/img/default_avatar.png" (click)="setSelected(index)" id="{{index}}" [ngClass] = "{'selected': profile.selected}"/>
            <img  *ngIf="profile.profile_avatar_path" src="{{profile.profile_avatar_path}}" (click)="setSelected(index)" id="{{index}}" [ngClass] = "{'selected': profile.selected}"/>
            <div class="profile-name" *ngIf="!profile.profile_nickName">{{profile.profile_firstName}}</div>
            <div class="profile-name" *ngIf="profile.profile_nickName">{{profile.profile_nickName}}</div>
            <!--
              <div class="edit" *ngIf= "parentProfile && !noEdit" (click)="editProfile(profile)"><img src="/../assets/img/edit-crayon.png" />modifier</div>
            -->
          </div>
          <div [hidden] = "!message" style="text-align: center; color: #fff; font-size: 1.6rem; margin-bottom: 20px;">{{message}}</div>
        </div>
        <ion-button class="connect" (click)="applyCode()" [hidden] = "!valid">{{ 'ACCOUNT.COUPON_ADD.BUTTON' | translate }}</ion-button>
      </form>
    </ion-list>
  </div>
</ion-content>
<ion-footer><app-bottom-menu></app-bottom-menu></ion-footer>
